// import { useEffect } from "react";
// import { Formik, Form, Field } from "formik";
// import { useDrainSlitComplaintReportStore } from "./useDrainSlitComplaintReportStore";
// import { useRfidStore } from "../../../Rfid/store/useRfidStore";
// import Select from "react-select";


// const AssignComplaintDetailsPopup = () => {
//   const {
//     selectedComplaint,
//     isAssigningComplaint,
//     setAssignComplaintDetailsModal,
//     assignDrainSiltComplaint,
//   } = useDrainSlitComplaintReportStore();
//   const { rfidDevices, fetchRfidDevices } = useRfidStore();

//   useEffect(() => {
//     fetchRfidDevices({ pageSize: 1000 });
//   }, [fetchRfidDevices]);

//   const initialValues = {
//     complaintNo: selectedComplaint?.complaintNo || "",
//     assignedVehicleId: "",
//   };

//   const onSubmit = async (values) => {
//     await assignDrainSiltComplaint(values);
//   };

//   return (
//     <Formik initialValues={initialValues} enableReinitialize onSubmit={onSubmit}>
//       <Form>
//         <div className="row">
//           <div className="col-md-6 mb-3">
//             <label className="form-label">Complaint Number</label>
//             <Field name="complaintNo" className="form-control bg-light" readOnly />
//           </div>

//           {/* <div className="col-md-6 mb-3">
//             <label className="form-label">
//               Assigned Complaint To (Vehicle) <span className="text-danger">*</span>
//             </label>
//             <Field as="select" name="assignedVehicleId" className="form-select bg-white">
//               <option value="">Select Vehicle</option>
//               {rfidDevices
//                 .filter((device) => device.isActive !== false)
//                 .map((device) => (
//                   <option key={device.rfidMasterId} value={device.rfidMasterId}>
//                     {device.rfidDeviceName}
//                   </option>
//                 ))}
//             </Field>
//           </div> */}


//         </div>

//         <div className="d-flex justify-content-end gap-2 mt-4">
//           <button
//             type="button"
//             onClick={() => setAssignComplaintDetailsModal(false)}
//             disabled={isAssigningComplaint}
//             style={{
//               padding: "8px 20px",
//               borderRadius: "4px",
//               border: "1px solid #1e40af",
//               background: "#ffffff",
//               color: "#1e40af",
//               fontSize: 14,
//               fontWeight: 500,
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             type="submit"
//             disabled={isAssigningComplaint}
//             style={{
//               padding: "8px 20px",
//               borderRadius: "4px",
//               border: "1px solid #003366",
//               background: "#003366",
//               color: "#ffffff",
//               fontSize: 14,
//               fontWeight: 500,
//             }}
//           >
//             {isAssigningComplaint ? "Saving..." : "Save"}
//           </button>
//         </div>
//       </Form>
//     </Formik>
//   );
// };

// export default AssignComplaintDetailsPopup;

import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDrainSlitComplaintReportStore } from "./useDrainSlitComplaintReportStore";
import Select from "react-select";
import axiosInstance from "../../../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../../../Services/baseApiUrl";

const AssignComplaintDetailsPopup = () => {
  const {
    selectedComplaint,
    isAssigningComplaint,
    setAssignComplaintDetailsModal,
    assignDrainSiltComplaint,
  } = useDrainSlitComplaintReportStore();

  const [rfidVehicles, setRfidVehicles] = useState([]);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await axiosInstance.get(
          `${API_BASE_URL1}MasterDetails/GetAllRFIDVehicles`
        );
        const data = response.data?.data || response.data || [];
        setRfidVehicles(data.filter((vehicle) => vehicle.isActive));
      } catch (error) {
        console.error("Error fetching RFID vehicles", error);
      }
    };
    fetchVehicles();
  }, []);

  const initialValues = {
    complaintNo: selectedComplaint?.complaintNo || "",
    assignedVehicleId: "",
  };
  const validationSchema = Yup.object().shape({
    assignedVehicleId: Yup.string().required("Assigned Complaint To (Vehicle) is required."),
  });

  const onSubmit = async (values) => {
    await assignDrainSiltComplaint(values);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, setFieldTouched }) => (
        <Form>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Complaint Number</label>
              <Field
                name="complaintNo"
                className="form-control bg-light"
                readOnly
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">
                Assigned Complaint To (Vehicle){" "}
                <span className="text-danger">*</span>
              </label>

              <Select
                name="assignedVehicleId"
                options={rfidVehicles
                  .filter((device) => device.isActive !== false)
                  .map((device) => ({
                    value: device.rfidMasterId || device.rfidmasterId || device.assetRfidId || device.rfidId,
                    label: device.otherNo || device.OtherNo || "Unknown",
                  }))}
                placeholder="Select Vehicle"
                isSearchable
                value={
                  rfidVehicles
                    .filter((device) => device.isActive !== false)
                    .map((device) => ({
                      value:
                        device.rfidMasterId ||
                        device.rfidmasterId ||
                        device.assetRfidId ||
                        device.rfidId,
                      label: device.otherNo || device.OtherNo || "Unknown",
                    }))
                    .find((option) => String(option.value) === String(values.assignedVehicleId)) || null
                }
                onChange={(option) => {
                  setFieldValue("assignedVehicleId", option?.value || "", true);
                  setFieldTouched("assignedVehicleId", true, false);
                }}
                onBlur={() => setFieldTouched("assignedVehicleId", true, false)}
              />
              <ErrorMessage
                className="text-danger"
                name="assignedVehicleId"
                component="div"
                style={{ fontSize: 12 }}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <button
              type="button"
              onClick={() => setAssignComplaintDetailsModal(false)}
              disabled={isAssigningComplaint}
              style={{
                padding: "8px 20px",
                borderRadius: "4px",
                border: "1px solid #1e40af",
                background: "#ffffff",
                color: "#1e40af",
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={isAssigningComplaint}
              style={{
                padding: "8px 20px",
                borderRadius: "4px",
                border: "1px solid var(--btn-primary-bg)",
                background: "var(--btn-primary-bg)",
                color: "var(--btn-primary-text)",
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              {isAssigningComplaint ? "Saving..." : "Save"}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AssignComplaintDetailsPopup;